import { createThunkRequest, POST } from '@webapp/account/src/libs/request';

import { mapPage } from '../common';

import { reverseMapPageParams } from './map';
import { NEW_PAGE_NAME } from './pages';
import { selectPages } from './selectors';

export const getPageList = createThunkRequest(
    'pages/getList',
    async ({ surveyId, refresh }: { surveyId: number; refresh?: boolean }) => {
        const { rows } = await POST('list/page', {
            survey: surveyId,
        });

        return {
            pages: rows.map(mapPage),
            refresh,
        };
    },
    { notify: false },
);

export const addPage = createThunkRequest(
    'pages/add',
    async (
        {
            surveyId,
            name,
            prev,
        }: {
            surveyId: number;
            name: string;
            prev?: number;
        },
        { dispatch },
    ) => {
        const data: {
            survey: number;
            title: string;
            prev?: number;
        } = {
            survey: surveyId,
            title: name,
        };

        if (prev) {
            data.prev = prev;
        }

        const { id, message } = await POST('add/page', data);

        if (id) {
            dispatch(getPageList({ surveyId, refresh: true }));
        }

        return {
            id,
            name,
            message,
            prev,
        };
    },
);

export const copyPage = createThunkRequest(
    'pages/copy',
    async ({ pageId, surveyId, name }: { surveyId: number; pageId: number; name: string }) => {
        const { id, message } = await POST('copy/page', {
            id: pageId,
            title: name,
        });

        return {
            pageId,
            message,
            newPageId: id,
            name,
            surveyId,
        };
    },
);

export const removePage = createThunkRequest(
    'pages/remove',
    async ({ pageId }: { pageId: number }, { dispatch, getState }) => {
        const state = getState();
        const pages = selectPages(state);
        const { message } = await POST('delete/page', {
            id: pageId,
        });

        if (pages.length <= 1) {
            const surveyId = state.Survey.activeSurveyId;
            await dispatch(addPage({ name: NEW_PAGE_NAME, surveyId }));
        }

        return { message, pageId };
    },
);

export const reorderPages = createThunkRequest(
    'pages/reorder',
    async ({ pageId, newOrder }: { pageId: number; newOrder: number }) =>
        await POST('change/page', {
            order: newOrder,
            id: pageId,
        }),
);

export const updatePageSettings = createThunkRequest(
    'pages/updateSettings',
    async ({ pageId, params }: { pageId: number; params: AnyObject }) => {
        const { message } = await POST('change/page', {
            id: pageId,
            ...reverseMapPageParams(params),
        });
        return { message, pageId, params };
    },
);
